import Header from "../components/Header";
import Footer from "../components/Footer";

const Layout = ({ children }) => {
  return (
    <div className="app-wrapper">
      <Header />
      <main className="app-body">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
